export const SHELL_TOP_BAR_PX = 64;
export const SHELL_FOOTER_PX = 64;
export const SHELL_SIDEBAR_WIDTH_PX = 240;
export const SHELL_NAV_ROW_HEIGHT_PX = 48;

export const VIEWPORT_2K_MIN_WIDTH_PX = 2200;

export const VIEWPORT_2K_MIN_MEDIA = `@media (min-width: ${VIEWPORT_2K_MIN_WIDTH_PX}px)`;

export const VIEWPORT_2K_MIN_WIDTH_MATCH = `(min-width: ${VIEWPORT_2K_MIN_WIDTH_PX}px)`;
export const SHELL_SIDEBAR_WIDTH_2K_PX = 268;
export const SHELL_NAV_ROW_HEIGHT_2K_PX = 52;

export const VIEWPORT_4K_MIN_WIDTH_PX = 3600;
export const VIEWPORT_4K_MIN_MEDIA = `@media (min-width: ${VIEWPORT_4K_MIN_WIDTH_PX}px)`;

export const VIEWPORT_4K_MIN_WIDTH_MATCH = `(min-width: ${VIEWPORT_4K_MIN_WIDTH_PX}px)`;
export const SHELL_SIDEBAR_WIDTH_4K_PX = 292;
export const SHELL_NAV_ROW_HEIGHT_4K_PX = 56;
export const SHELL_NAV_GAP_PX = 8;
export const SHELL_NAV_ROW_INNER_SPACING = 1.5;

export const SHELL_MAIN_CHROME_PADDING_PX = 24;

export const TABLE_PAGE_VIEWPORT_SUBTRACT_PX =
  SHELL_TOP_BAR_PX + SHELL_FOOTER_PX;
export const TABLE_PAGE_CONTAINER_HEIGHT = `calc(100vh - ${TABLE_PAGE_VIEWPORT_SUBTRACT_PX}px)`;
